import $ from 'jquery';

const elements = {
  $hotSpots: $('.c-hotspot__spot'),
  activeIndex: -1,
};

// set up debounced position check
var debouncePositionCheck = debounce(function(activeIndex) {
  setUpPositioning(activeIndex);
}, 250);

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function resetMargin(element) 
{   
  $(element).css({ marginLeft: '0' });
}

function setUpPositioning(activeElement) 
{        
  // set up positioning
  const tooltip = $(activeElement).next('.c-hotspot__message');
  const tooltip_arrow = tooltip.find('.c-hotspot__arrow');
  const tooltip_rect = tooltip[0].getBoundingClientRect();

  if ((tooltip_rect.right) > $(window).width()) { // off on the right
    const offset = tooltip_rect.right - $(window).width();
    const tipX = offset;
    tooltip.css({ marginLeft: -tipX });
    tooltip_arrow.css({ marginLeft: tipX });
  }

  if ((tooltip_rect.left) < 0) { // off on the left
    const offset = Math.abs(tooltip_rect.left);
    tooltip.css({ marginLeft: offset });
    tooltip_arrow.css({ marginLeft: -offset });
  }

  $('.c-hotspot__close').click(function(){
    closeActive(this);
    resetMargin($(this).parent());
    $('.c-hotspot__spot').removeClass("c-hotspot__spot--active");
    $('.c-hotspot__spot').attr('aria-expanded', 'false');
    elements.activeIndex = -1;
  });
}

function clearActive(activeElement) 
{ 
  $('.c-hotspot__spot--active').not(activeElement).removeClass('c-hotspot__spot--active');
  $('.c-hotspot__spot').not(activeElement).attr('aria-expanded', 'false');
  $(activeElement).toggleClass('c-hotspot__spot--active');
  // $(activeElement).attr('aria-expanded', 'true');
}

function closeActive(activeElement) 
{ 
  $(activeElement).parent().hide(); // parent c-hotspot__message
}

function setUpMarkerClick() {
  elements.$hotSpots.each(function(index) {
  // set up click event
    $(this).click(function() {
      if ( $(this).next(".c-hotspot__message").is(":visible")) {
        $(this).attr('aria-expanded', 'false');
        $(this).next(".c-hotspot__message").hide();
        elements.activeIndex = -1;
        clearActive(this);
        return;
      }
      $('.c-hotspot__message').attr('aria-expanded', 'false');
      $('.c-hotspot__message').hide();
      $(this).attr('aria-expanded', 'true');
      $(this).next('.c-hotspot__message').show();

      setUpPositioning(this);
      clearActive(this);
      elements.activeIndex = index;
    });
  });
}

function init() {
  setUpMarkerClick();
  // on window size check tooltip oositioning
  $(window).on('resize', function(){
    if(elements.activeIndex != -1) {
      resetMargin(".c-hotspot__message, .c-hotspot__arrow");
      var currentActiveToolTip = elements.$hotSpots[elements.activeIndex]
      debouncePositionCheck(currentActiveToolTip);
    }
  })
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/hotspot/hotspot.js